export var SystemType;
(function (SystemType) {
    SystemType["EVOLVETYPE"] = "evolve";
    SystemType["VSTTYPE"] = "vst";
})(SystemType || (SystemType = {}));
